import { OnboardingInputType, OnboardingStepType } from '@account_module/types/Onboarding';

type MegaphopneIntegrationQueryKey = 'megaphone-networks' | 'megaphone-shows-by-network-id';

export const ONBOARDING_FORM_KEYS = {
  API_TOKEN: 'api_token' as OnboardingInputType,
  ORG_ID: 'organization_id' as OnboardingInputType,
};

export const MEGAPHONE_ONBOARDING_STEP_KEYS = {
  VERIFY_CREDENTIALS: 'verify_credentials' as OnboardingStepType,
  CUSTOMIZE_IMPORT: 'customize_import' as OnboardingStepType,
  HANDLE_DUPLICATE: 'handle_dupicate' as OnboardingStepType,
  SUCCESS: 'success' as OnboardingStepType,
};

export const MEGAPHONE_INTEGRATION_QUERY_KEY = {
  NETWORKS: 'megaphone-networks' as MegaphopneIntegrationQueryKey,
  SHOWS_BY_NETWORK_ID: 'megaphone-shows-by-network-id' as MegaphopneIntegrationQueryKey,
};
